import { useQuery } from "@tanstack/react-query";
import QueryGlobalInterface from "interfaces/queryInterface";
import { toast } from "react-toastify";
import instance from "services/axiosServices";
import leadsWebEnviroment from "utils/leadsWebEnviroment";

export interface atendimentosProps {
  idLocalVendas: string | undefined | null;
  params: string;
}

export function useListarAtendimentos(
  props: atendimentosProps & QueryGlobalInterface
) {
  const fetchData = async () => {
    const LISTAR_ATENDIMENTOS = `${leadsWebEnviroment}/app-web/atendimentos/v1/${props.idLocalVendas}${props?.params}`;
    const response = await instance.get(LISTAR_ATENDIMENTOS);
    const dataWithPagination = {
      data: response?.data?.data,
      pagination: response?.data?.pagination,
    };
    return dataWithPagination;
  };
  const query = useQuery({
    queryFn: () => fetchData(),
    queryKey: [props.queryKey],
    refetchOnWindowFocus: false,
    enabled: false,
    retry: false,
    onError: (error: any) => {
      const notifications = error?.response?.data?.notifications;
      const errorMessages = Array.isArray(notifications)
        ? notifications.map((item: any) => `${item?.message}`).join("\n")
        : "Erro desconhecido ao listar atendimentos";

      toast.error(`Erro ao listar atendimentos. Motivos:\n${errorMessages}`, {
        autoClose: 10000,
      });
    },
  });
  return query;
}
